import React, {Component} from 'react';
import {withRouter} from 'react-router-dom'
import UserNav from "./UserNav";
import UserService from "../../services/UserService";

class NavHeader extends Component {

  constructor(props) {
    super(props);
    this.state = {currentUser: UserService.currentUser};
  }

  componentWillReceiveProps(nextProps) {
    this.setState({currentUser: UserService.currentUser});
  }

  render() {
    const {currentUser} = this.state;
    if (currentUser) {
      return (
          <UserNav currentUser={currentUser}/>
      );
    }

    return '';

  };
}

export default withRouter(NavHeader);


// WEBPACK FOOTER //
// ./src/component/Navbar/NavHeader.js